import React, { CSSProperties, useMemo, useRef } from 'react';
import * as styles from './ExpandableList.css';

type TProps = {
  isExpanded: boolean;
  children: React.ReactNode;
};
export const ExpandableList = ({ isExpanded, children }: TProps) => {
  const blockRef = useRef<HTMLUListElement>(null);

  const style = useMemo<CSSProperties>(
    () => ({
      maxHeight: isExpanded ? blockRef.current?.scrollHeight : 0,
    }),
    [isExpanded],
  );

  return (
    <ul style={style} ref={blockRef} className={styles['list']}>
      {children}
    </ul>
  );
};
